import React from 'react';
import classNames from 'classnames';
import { currency } from 'Helpers/Formats';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  root: {},
  rootColorAccentBlue: {
    color: theme.palette.facet.accentBlue,
    '&:hover': {
      color: theme.palette.facet.accentBlue,
    },
  },
  rootColorAccentGreen: {
    color: theme.palette.facet.accentGreen,
    '&:hover': {
      color: theme.palette.facet.accentGreen,
    },
  },
  secondaryDetail: {
    textAlign: 'right',
  },
});

const ReadOnlyItem = ({
  className,
  classes,
  name,
  balance,
  color,
}) => {
  return (
    <ListItem
      className={classNames(className, classes.root, {
        [classes.rootColorAccentBlue]: color === 'accentBlue',
        [classes.rootColorAccentGreen]: color === 'accentGreen',
      })}
    >
      <ListItemText
        primary={name}
        primaryTypographyProps={{
          variant: 'h5',
          noWrap: true,
        }}
      />
      <ListItemText
        className={classes.secondaryDetail}
        primary={currency(parseFloat(balance), true)}
        primaryTypographyProps={{
          variant: 'h5',
          noWrap: true,
        }}
      />
    </ListItem>
  );
};

ReadOnlyItem.defaultProps = {
  className: '',
};

ReadOnlyItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  balance: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['accentBlue', 'accentGreen']).isRequired,
};

export default withStyles(styles)(ReadOnlyItem);
